import { useState } from 'react'

import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect'
import { DESKTOP_MIN_WIDTH } from 'styles/theme'

const mobileMaxWidth = DESKTOP_MIN_WIDTH - 1

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false)

  useIsomorphicLayoutEffect(() => {
    const mq = window.matchMedia(query)
    setMatches(mq.matches)

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)

    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [query])

  return matches
}

export const useIsMobile = () =>
  useMediaQuery(`(max-width: ${mobileMaxWidth}px)`)
